import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";

function openChat() {
  window.dispatchEvent(new CustomEvent("seedtech:open-chat"));
}

export default function Navbar() {
  return (
    <nav className="sticky top-0 z-30 border-b border-border/60 bg-cream/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 sm:px-12">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 font-display text-xl font-semibold text-umber">
          <span className="grid h-8 w-8 place-items-center rounded-md bg-umber text-cream">S</span>
          SeedTech<span className="text-terracotta">NG</span>
        </Link>
        <div className="hidden items-center gap-8 text-sm text-umber/80 md:flex">
          <a data-testid="nav-services" href="#services" className="hover:text-umber">Services</a>
          <a data-testid="nav-how" href="#how-it-works" className="hover:text-umber">How it works</a>
          <a data-testid="nav-pricing" href="#pricing" className="hover:text-umber">Pricing</a>
          <a data-testid="nav-funders" href="#funders" className="hover:text-umber">Funders</a>
          <a data-testid="nav-faq" href="#faq" className="hover:text-umber">FAQ</a>
        </div>
        <div className="flex items-center gap-3">
          <Link
            data-testid="nav-admin-link"
            to="/admin/login"
            className="hidden text-xs uppercase tracking-wider text-umber/60 hover:text-umber sm:inline"
          >
            Staff
          </Link>
          <button
            data-testid="nav-talk-to-us"
            onClick={openChat}
            className="inline-flex items-center gap-2 rounded-md bg-umber px-4 py-2 text-sm font-medium text-cream transition hover:-translate-y-0.5 hover:bg-umber-dark"
          >
            <MessageCircle className="h-4 w-4" /> Talk to us
          </button>
        </div>
      </div>
    </nav>
  );
}
